import React from 'react';
import LandingPage from './ui/pages/landing';

const App: React.FC = () => {
  return <LandingPage />;
};

export default App;